export function convertHEIC(imagePath = '') {
    if (imagePath?.toLowerCase().endsWith('.heic')) {
        imagePath = `${imagePath.split('.')[0]}.jpg`;
    }
    return imagePath;
}

export function getFileName(imagePath) {
    const splitUri = (imagePath || '').split('/');
    return(splitUri.pop().split('.')[0]);
}

export function getUrlExtension(url) {
    if (typeof url === 'string') {
        return url.split('.').pop().trim() || '';
    }
    else {
        return('');
    }
}
